<template>
  <div id="fullpage">


    <!-- Banner Area Starts -->
    <section class="banner-area section index_banner_box">




      <div
        class="banner_swiper swiper-container swiper-container-fade swiper-container-initialized swiper-container-horizontal">
        <div class="swiper-wrapper" style="transition-duration: 0ms;">

          <div v-for="(item, index) in bannerlist" :key="index" class="swiper-slide" :data-swiper-slide-index="index"
            style="width: 1903px; opacity: 1; transition-duration: 0ms; margin-right:0px !important;">
            <div class="img_box">
              <img :src="item.pic" class="ani" swiper-animate-effect="toSmall" swiper-animate-duration="5s"
                swiper-animate-delay="0s" style="visibility: hidden;" swiper-animate-style-cache="visibility: hidden;">
            </div>
            <div class="text_box">
              <h3 class="ani fadeInUp80 animated" swiper-animate-effect="fadeInUp80" swiper-animate-duration="1s"
                swiper-animate-delay="0s"
                style="visibility: visible;animation-duration:1s;-webkit-animation-duration:1s;animation-delay:0s;-webkit-animation-delay:0s;"
                swiper-animate-style-cache="visibility: hidden;">
                {{ item.title }}
              </h3>
              <h2 class="ani fadeInUp80 animated" swiper-animate-effect="fadeInUp80" swiper-animate-duration="1s"
                swiper-animate-delay="0s"
                style="visibility: visible;animation-duration:1s;-webkit-animation-duration:1s;animation-delay:0s;-webkit-animation-delay:0s;"
                swiper-animate-style-cache="visibility: hidden;">
                {{ item.subtitle }}
              </h2>
              <!-- <img src="/static/assets/images/bailogo.png" alt="" class="ani fadeInUp80 animated"
                swiper-animate-effect="fadeInUp80" swiper-animate-duration="1s" swiper-animate-delay="1s"
                style="visibility: visible;animation-duration:1s;-webkit-animation-duration:1s;animation-delay:1s;-webkit-animation-delay:1s;"
                swiper-animate-style-cache="visibility: hidden;"> -->
            </div>
          </div>
        </div>
        <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
      </div>
      <div class="banner_thumber swiper-container-initialized swiper-container-horizontal swiper-container-thumbs">
        <div class="swiper-wrapper" style="transform: translate3d(0px, 0px, 0px); transition-duration: 0ms;">
          <div class="swiper-slide" v-for="(item, index) in bannerlist" :key="index">
            <span></span>
            <p style="white-space: normal;">{{ item.subtitle }}</p>
            <p style="white-space: normal;">{{ item.title }}</p>
            <div class="xz">
              <div class="progressb">
                <div class="circle" data-name="CSS Skill" data-percent="100%">
                  <svg viewBox="-10 -10 220 220">
                    <g fill="none" stroke-width="6" transform="translate(100,100)">
                      <path
                        d="M 0,-100 A 100,100 0 0,1 86.6,-50 A 100,100 0 0,1 86.6,50 A 100,100 0 0,1 0,100 A 100,100 0 0,1 -86.6,50 A 100,100 0 0,1 -86.6,-50 A 100,100 0 0,1 0,-100">
                      </path>
                    </g>
                  </svg>
                  <svg viewBox="-10 -10 220 220">
                    <path
                      d="M200,100 C200,44.771525 155.228475,0 100,0 C44.771525,0 0,44.771525 0,100 C0,155.228475 44.771525,200 100,200 C155.228475,200 200,155.228475 200,100 Z"
                      stroke-dashoffset="629"></path>
                  </svg>
                </div>
              </div>
              <div class="jt">
                <img src="/static/assets/images/jz.svg" alt="">
              </div>
            </div>
          </div>

        </div>
        <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
      </div>




    </section>
    <!-- Banner Area End -->


    <!-- Feature Area Starts 产品中心适配 -->
    <section class="section feature-area section-padding2"
      style="background: url('../static/assets/images/producis.png') no-repeat;">


      <!-- 产品中心电脑适配 -->

      <div class="wow fadeInUp sun913pc"
        style="width: 100%; height: 120px; text-align: center; position: absolute;  top:0px;  ">
        <p style="font-size: 24px; color: #44BCB9;margin-top: 150px;" class="phonecpzt">PRODUCTS</p>
        <p style="font-size: 24px;">产品中心</p>
      </div>

      <div class="container homecp912 sun913pc">
        <div class="row">

          <div v-for="(item, index) in lanmulist" :key="index" class="col-lg-4 texiao donghuasun"
            style="animation-duration:1s; animation-delay: 0.3s; visibility: visible;max-width: 19%;">
            <a :href="'/category?id=' + item.scode" target="_blank" style="color: black;">
              <div class="single-feature mb-4 mb-lg-0">
                <h4 style="height: 45px;">{{ item.name }}</h4>
                <div class="line"></div>
                <p>{{ item.subname }}</p>
                <div class="xincpfm">
                  <img :src="newurl + item.ico" alt="Your Image" class="shrinkable-image">
                </div>


                <!-- <div class="image-container">
                  <img :src="newurl + item.ico" alt="Your Image" class="shrinkable-image">
                </div> -->
                <!-- <div class="secondary-btn">
                  <div class="spana">
                    <div style="bottom: 9%;  position: absolute;  right: 30px;  font-size: 50px;" class="phonezt">
                      0{{ index + 1 }}</div>
                    <img src="/static/assets/images/sanjiao.png" />
                  </div>
                </div> -->
              </div>
            </a>
          </div>

        </div>
      </div>

      <!-- 产品中心手机适配 -->
      <div class="sun913sj" style="max-width:100%;height:100%;">
        <div style="width: 100%; height: 15%; text-align: center; position: absolute;top: 0px;">
          <p style="font-size: 24px; color: #44BCB9;margin-top: 150px;" class="phonecpzt">PRODUCTS</p>
          <p style="font-size: 24px;">产品中心</p>
        </div>

        <div class="homecp912" style="max-width:100%; height: 85%; position: absolute; width: 100%; bottom: 0px; background:url('../static/assets/images/beijzz.png') no-repeat bottom; background-size:100%;">


          <div v-for="(item, index) in lanmulist" :key="index" class="col-lg-4 texiao donghuasun"
            style="animation-duration:1s; animation-delay: 0.3s; width: 45%;margin-left:3% ; float: left; ">
            <a :href="'/category?id=' + item.scode" target="_blank" style="color: black;">
              <div class="single-feature mb-4 mb-lg-0" style="height: 90%;padding: 0px;border-radius: 6px;">
                <div style="width: 100%;height: 140px; text-align: center; bottom: 15%;right: 0px;">
                  <img :src="newurl + item.ico" alt="Your Image" class="shrinkable-image" style="width: 100%;">
                </div>
                <div class="line" style="width: 100%;"></div>
                <div style="height: 60%; line-height:40px; font-size:16px; text-align: center;">
                  {{ truncatechanpin(item.name) }}
                </div>
                
                <!-- <p style="font-size:14px">{{ item.subname }}</p> -->
                


                <!-- <div class="image-container">
                        <img :src="newurl + item.ico" alt="Your Image" class="shrinkable-image">
                      </div> -->
                <!-- <div class="secondary-btn">
                        <div class="spana">
                          <div style="bottom: 9%;  position: absolute;  right: 30px;  font-size: 50px;" class="phonezt">
                            0{{ index + 1 }}</div>
                          <img src="/static/assets/images/sanjiao.png" />
                        </div>
                      </div> -->
              </div>
            </a>
          </div>

        </div>
      </div>




    </section>

    <!-- Feature Area End -->

    <!-- Category Area Starts -->
    <section class="category-area section-padding section  section-padding99"
      style="background: url('../static/assets/images/solve_bg.jpg') no-repeat center;">
      <div class="container donghuasun">
        <div style="width: 100%;height: 120px;text-align: center;">
          <p style="font-size: 24px; color: #44BCB9;">SOLUTIONS</p>
          <p style="font-size: 24px; color: #ffffff;">解决方案</p>
        </div>



      </div>

      <!--手机适配-->
      <div class="sun913sj" style="animation-duration: 1s; animation-delay: 0.3s; visibility: visible;">
        <ul>
          <a :href="'/jiejueinfo?id=' + fanganlist[2].id" target="_blank" style="color: black;">
          <li class="idx_falist1" style="background-image: url('../static/assets/images/idxfaimg1.jpg'); left: 0px;height: 140px; background-size: 100%; margin-bottom: 5px;">
              <div  style="    width: 100%;  height: 50px;  line-height: 50px;  color: #fff; padding: 50px;">
                {{ fanganlist[2]['title'] }}
              </div>
          </li>
        </a>
          <!-- <li class="idx_falist2" :style="'background-image: url(' + newurl + fanganlist[1]['pics'] + '); left: 25%;'"> -->
            <a :href="'/jiejueinfo?id=' + fanganlist[1].id" target="_blank" style="color: black;">
          <li class="idx_falist2" style="background-image: url('../static/assets/images/idxfaimg2.jpg'); left: 0px;height: 140px; background-size: 100%; margin-bottom: 5px;">
              <div style="    width: 100%;  height: 50px;  line-height: 50px;  color: #fff; padding: 50px;">
                {{ fanganlist[1]['title'] }}
              </div>
          </li>
        </a>
          <!-- <li class="idx_falist3 active"
            :style="'background-image: url(' + newurl + fanganlist[0]['pics'] + '); left: 50%;'"> -->
            <a :href="'/jiejueinfo?id=' + fanganlist[0].id" target="_blank" style="color: black;">
          <li class="idx_falist3 active" 
            style="background-image: url('../static/assets/images/idxfaimg3.jpg'); left: 0px;height: 140px; background-size: 100%; margin-bottom: 5px;">
            
              <div style="    width: 100%;  height: 50px;  line-height: 50px;  color: #fff; padding: 50px;">
                {{ fanganlist[0]['title'] }}
              </div>
           
          </li>
        </a>
        </ul>
        <div class="idx_sun">
          <span class="sun_xza" style="padding-right: 30px;">●</span>
          <span class="sun_xzb" style="padding-left:30px;">●</span>
          <span class="sun_xzc" style="padding-left:60px;">●</span>
        </div>
      </div>

      <!--电脑适配-->
      <div class="idx_fa  animate fadeInUp animated donghuasun sun913pc"
        style="animation-duration: 1s; animation-delay: 0.3s; visibility: visible;">
        <ul>

          <li class="idx_falist1" style="background-image: url('../static/assets/images/idxfaimg1.jpg'); left: 0px;">
            <!-- <li class="idx_falist1" :style="'background-image: url(' + newurl + fanganlist[2]['pics'] + '); left: 0px;'"> -->

            <a :href="'/jiejueinfo?id=' + fanganlist[2].id" target="_blank" style="color: black;">
              <div class="idxfa_title flexrow">
                <h3 style="font-size:16px;">{{ fanganlist[2]['title'] }}</h3>
              </div>
              <div class="idx_fadesc  animate fadeIn animated" data-animate="fadeIn" data-duration="1.5s"
                data-delay="0.1s" style="animation-duration: 1.5s; animation-delay: 0.1s; visibility: visible;">
                <h3 style="font-size:16px;">{{ fanganlist[2]['title'] }}</h3>
                <div class="idx_fadesc_item ">
                  <p>{{ fanganlist[2]['description'] }}</p>
                  <button style="font-size:16px;">了解更多 &gt;</button>
                </div>
              </div>
            </a>
          </li>
          <!-- <li class="idx_falist2" :style="'background-image: url(' + newurl + fanganlist[1]['pics'] + '); left: 25%;'"> -->
          <li class="idx_falist2" style="background-image: url('../static/assets/images/idxfaimg2.jpg'); left: 25%;">
            <a :href="'/jiejueinfo?id=' + fanganlist[1].id" target="_blank" style="color: black;">
              <div class="idxfa_title flexrow">
                <h3 style="font-size:16px;">{{ fanganlist[1]['title'] }}</h3>
              </div>
              <div class="idx_fadesc  animate fadeIn animated" data-animate="fadeIn" data-duration="1.5s"
                data-delay="0.1s" style="animation-duration: 1.5s; animation-delay: 0.1s; visibility: visible;">
                <h3 style="font-size:16px;">{{ fanganlist[1]['title'] }}</h3>
                <div class="idx_fadesc_item ">
                  <p>{{ fanganlist[1]['description'] }}</p>
                  <button style="font-size:16px;">了解更多 &gt;</button>
                </div>
              </div>
            </a>
          </li>
          <!-- <li class="idx_falist3 active"
            :style="'background-image: url(' + newurl + fanganlist[0]['pics'] + '); left: 50%;'"> -->
          <li class="idx_falist3 active"
            style="background-image: url('../static/assets/images/idxfaimg3.jpg'); left: 50%;">
            <a :href="'/jiejueinfo?id=' + fanganlist[0].id" target="_blank" style="color: black;">
              <div class="idxfa_title flexrow">
                <h3 style="font-size:16px;">{{ fanganlist[0]['title'] }}</h3>
              </div>
              <div class="idx_fadesc  animate fadeIn animated" data-animate="fadeIn" data-duration="1.5s"
                data-delay="0.1s" style="animation-duration: 1.5s; animation-delay: 0.1s; visibility: visible;">
                <h3 style="font-size:16px;">{{ fanganlist[0]['title'] }}</h3>
                <div class="idx_fadesc_item ">
                  <p>{{ fanganlist[0]['description'] }}</p>
                  <button style="font-size:16px;">了解更多 &gt;</button>
                </div>
              </div>

            </a>
          </li>
        </ul>
        <div class="idx_sun">
          <span class="sun_xza" style="padding-right: 30px;">●</span>
          <span class="sun_xzb" style="padding-left:30px;">●</span>
          <span class="sun_xzc" style="padding-left:60px;">●</span>
        </div>
      </div>

    </section>
    <!-- Category Area End -->

    <!-- Jobs Area Starts -->
    <section class="jobs-area section-padding3 section">
      <div class="container homecontainer " style="position: absolute;  top: 15%;  margin-left: 10%;">
        <div class="donghuasun about_sun"
          style="width: 100%;height: 120px;text-align: center;animation-duration: 0.5s; animation-delay: 0.3s;">
          <p style="font-size: 24px; color: #44BCB9;font-weight: bold;">ABOUT US</p>
          <p style="font-size: 24px;">公司简介</p>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="donghuaLeft"
              style="animation-duration: 1s; animation-delay: 0.5s;width: 50%;float: left;padding-right: 5%;">
              <p class="homeaboutsj" style="font-weight: bold;font-size: 18px;">专注于工业自动化测控领域的应用产品开发与技术服务</p>
              <p class="hongaboutsja" style="color: #666666;line-height: 34px;">
                {{ aboutinfo.description }}
              </p>
            </div>
            <div class="donghuaRight llsunz" style="width: 40%;float: left; animation-duration: 1s; animation-delay: 1s;">
              <img :src="newurl + aboutinfo.ico" style="width:100%" />
            </div>

          </div>
        </div>
        <div class="more-job-btn mt-5 text-center donghuasunfadeIn liaojiesunbbc"
          style="animation-duration: 1s; animation-delay: 1.5s;">
          <a href="/about" target="_blank" class="template-btn">了解更多</a>
        </div>
      </div>
    </section>
    <!-- Jobs Area End -->

    <!-- Newsletter Area Starts -->
    <section class="section-padding4 section" style="width: 100% !important;">
      <div class="sun">
        <!--第一列-->
        <div class="suna">
          <div class="suna_a donghuaDown" style="animation-duration: 0.5s; animation-delay: 0.3s;">

            <div style="width: 100%;height: 100%; display: flex; align-items: center;">
              <div class="ipahyyy" style="width: 40%;height:50%;text-align: right;margin-left: 15%;">
                <p style="font-size: 24px; color: #ffffff;font-weight: 500;margin-left: -4px;" class="hyyy_new_ywzt">
                  INDUSTRIES</p>
                <p style="font-size: 24px;" class="hyyy_new_zt">行业应用</p>
              </div>

            </div>


          </div>
          <div class="suna_b donghuasunfadeIn" style="animation-duration: 0.6s; animation-delay: 0.6s;">

            <div class="idx_pros">
              <ul>
                <li class="animate fadeInUp animated" data-animate="fadeInUp" data-duration="2s" data-delay="1s"
                  style="animation-duration: 1s; animation-delay: 0.1s; visibility: visible;">
                  <a href="/yingyong">
                    <img :src="newurl + hangyelist[1]['ico']">
                    <div class="idx_pros_desc flexrow">

                      <div style="color: #ffffff;  text-align: left;    line-height: 36px; padding: 10%;"
                        class="kongnidiv">
                        <p class="hangyeyingyong"><strong>{{ hangyelist[1]['title'] }}</strong></p>
                        <p class="buxianshi">{{ hangyelist[1]['description'] }}</p>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>

          </div>
        </div>

        <!--第二列-->
        <div class="sunb">
          <div class="sunb_a donghuasunfadeIn" style="animation-duration: 0.6s; animation-delay: 0.6s;">
            <div class="idx_pros">
              <ul>
                <li class="animate fadeInUp animated" data-animate="fadeInUp" data-duration="2s" data-delay="1s"
                  style="animation-duration: 1s; animation-delay: 0.1s; visibility: visible;">
                  <a href="/yingyong">
                    <img :src="newurl + hangyelist[3]['ico']">
                    <div class="idx_pros_desc flexrow">

                      <div style="color: #ffffff;  text-align: left;    line-height: 36px; padding: 10%;"
                        class="kongnidiv">
                        <p class="hangyeyingyong"><strong>{{ hangyelist[3]['title'] }}</strong></p>
                        <p class="buxianshi">{{ hangyelist[3]['description'] }}</p>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>

          </div>
          <div class="sunb_b donghuasunfadeIn" style="animation-duration: 0.6s; animation-delay: 0.6s;">

            <div class="idx_pros">
              <ul>
                <li class="animate fadeInUp animated" data-animate="fadeInUp" data-duration="2s" data-delay="1s"
                  style="animation-duration: 1s; animation-delay: 0.1s; visibility: visible;">
                  <a href="/yingyong">
                    <img :src="newurl + hangyelist[0]['ico']">
                    <div class="idx_pros_desc flexrow">

                      <div style="color: #ffffff;  text-align: left;    line-height: 36px; padding: 10%;"
                        class="kongnidiv">
                        <p class="hangyeyingyong"><strong>{{ hangyelist[0]['title'] }}</strong></p>
                        <p class="buxianshi">{{ hangyelist[0]['description'] }}</p>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>

          </div>
        </div>

        <!--第三列-->
        <div class="sunc">

          <div class="idx_pros donghuasunfadeIn" style="animation-duration: 0.6s; animation-delay: 0.6s;">
            <ul>
              <li class="animate fadeInUp animated" data-animate="fadeInUp" data-duration="2s" data-delay="1s"
                style="animation-duration: 1s; animation-delay: 0.1s; visibility: visible;">
                <a href="/yingyong">
                  <img :src="newurl + hangyelist[2]['ico']">
                  <div class="idx_pros_desc flexrow">

                    <div style="color: #ffffff;  text-align: left;    line-height: 36px; padding: 10%;" class="kongnidiv">
                      <p class="hangyeyingyong"><strong>{{ hangyelist[2]['title'] }}</strong></p>
                      <p class="buxianshi">{{ hangyelist[2]['description'] }}</p>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </section>
    <!-- Newsletter Area End -->





    <!-- naduyoushi starts-->
    <section class="section-padding6 section">
      <div class="container donghuasun" style="animation-duration: 1s; animation-delay: 0.3s;">
        <div style="width: 100%;height: 120px;text-align: center;">
          <p style="font-size: 24px; color: #44BCB9;">ADVANTAGES</p>
          <p style="font-size: 24px; color: #666666;">拿度优势</p>
        </div>
      </div>
      <div class="homeyoushi" style="width: 100%;">

        <div class="advantage_num donghuaIn" style="animation-duration: 1.5s; animation-delay: 1s;">
          <ul>
            <li class="donghuasun" style="animation-duration: 1.5s; animation-delay: 0.4s;">
              <!-- <li class="wow fadeInLeft animated" style="visibility: visible; animation-name: fadeInLeft;"> -->
              <div class="img_box"><img src="/static/assets/images/advantage01.jpg" alt=""></div>
              <div class="text_box">
                <span>
                  <em>6</em><i>大</i>
                </span>
                <p>主要业务板块，<br>
                  磁致伸缩位移传感器、激光传感器</p>
              </div>
            </li>

            <li class="" style="animation-duration: 1.5s; animation-delay: 0.7s;">
              <!-- <li class="wow fadeInLeft animated" style="visibility: visible; animation-name: fadeInLeft;"> -->
              <div class="img_box"><img src="/static/assets/images/advantage02.jpg" alt=""></div>
              <div class="text_box">
                <span><em>10</em><i>年</i></span>
                <p>十年以上的行业经验，<br>
                  强大的传感器研发、设计和测试工程师团队</p>
              </div>
            </li>
            <!-- <li class="wow fadeInLeft animated" style="visibility: visible; animation-name: fadeInLeft;"> -->
            <li class="donghuasun" style="animation-duration: 1.5s; animation-delay: 0.9s;">
              <div class="img_box"><img src="/static/assets/images/advantage03.jpg" alt=""></div>
              <div class="text_box">
                <span><em>60</em><i>种</i></span>
                <p>位移传感器产品，<br>
                  技术上追求“度”，做事上立本于“度”</p>
              </div>
            </li>

          </ul>
        </div>
      </div>
    </section>
    <!-- naduyoushi end-->


    <!-- Employee Area Starts -->
    <section class="section-padding5 section" style="width: 100% !important;">
      <div class="sun">
        <!--第一列-->
        <div class="suna">


          <div class="idx_pros donghuaIn" style="animation-duration: 0.6s; animation-delay: 0.1s;">
            <ul>
              <li class="animate fadeInUp animated" data-animate="fadeInUp" data-duration="2s" data-delay="1s"
                style="animation-duration: 1s; animation-delay: 0.1s; visibility: visible;">
                <a href="/fuwu">
                  <img :src="newurl + fuwulist[0]['ico']">

                  <div class="idx_pros_desc flexrow">

                    <div style="color: #ffffff;  text-align: center; line-height: 46px; padding: 10%;" class="jsfw_1108">
                      <p style="font-size: 24px; font-weight: 500;">TECHNICAL SERVICE</p>
                      <p style="font-size: 24px;color: #44BCB9;">技术服务</p>

                      <p style="font-size: 16px;margin-top: 100px;" class="jsfw_new_zt">{{ fuwulist[0]['description'] }}
                      </p>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </div>


        </div>

        <!--第二列-->
        <div class="sunb">

          <div class="sunb_a">

            <div class="sunb_a_a donghuaIn" style="animation-duration: 0.6s; animation-delay: 0.4s;">
              <div class="idx_pros">
                <ul>
                  <li class="animate fadeInUp animated" data-animate="fadeInUp" data-duration="2s" data-delay="1s"
                    style="animation-duration: 1s; animation-delay: 0.1s; visibility: visible;">
                    <a href="/fuwu">
                      <img :src="newurl + fuwulist[4]['ico']">
                      <div class="idx_pros_desc flexrow">

                        <div style="color: #ffffff;  text-align: left;    line-height: 36px; padding: 10%;">
                          <p class="hangyeyingyong"><strong>{{ fuwulist[4]['title'] }}</strong></p>
                          <p class="buxianshi">{{ fuwulist[4]['description'] }}</p>
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="sunb_a_b donghuaIn" style="animation-duration: 0.6s; animation-delay: 0.7s;">
              <div class="idx_pros">
                <ul>
                  <li class="animate fadeInUp animated" data-animate="fadeInUp" data-duration="2s" data-delay="1s"
                    style="animation-duration: 1s; animation-delay: 0.1s; visibility: visible;">
                    <a href="/fuwu">
                      <img :src="newurl + fuwulist[3]['ico']">
                      <div class="idx_pros_desc flexrow">

                        <div style="color: #ffffff;  text-align: left;    line-height: 36px; padding: 10%;">
                          <p class="hangyeyingyong"><strong>{{ fuwulist[3]['title'] }}</strong></p>
                          <p class="buxianshi">{{ fuwulist[3]['description'] }}</p>
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

          </div>

          <div class="sunb_b">
            <div class="sunb_b_a donghuaIn" style="animation-duration: 0.6s; animation-delay: 1.1s;">
              <div class="idx_pros">
                <ul>
                  <li class="animate fadeInUp animated" data-animate="fadeInUp" data-duration="2s" data-delay="1s"
                    style="animation-duration: 1s; animation-delay: 0.1s; visibility: visible;">
                    <a href="/fuwu">
                      <img :src="newurl + fuwulist[2]['ico']">
                      <div class="idx_pros_desc flexrow">

                        <div style="color: #ffffff;  text-align: left;    line-height: 36px; padding: 10%;">
                          <p class="hangyeyingyong"><strong>{{ fuwulist[2]['title'] }}</strong></p>
                          <p class="buxianshi">{{ fuwulist[2]['description'] }}</p>
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="sunb_b_b donghuaIn" style="animation-duration: 0.6s; animation-delay: 1.4s;">
              <div class="idx_pros">
                <ul>
                  <li class="animate fadeInUp animated" data-animate="fadeInUp" data-duration="2s" data-delay="1s"
                    style="animation-duration: 1s; animation-delay: 0.1s; visibility: visible;">
                    <a href="/fuwu">
                      <img :src="newurl + fuwulist[1]['ico']">
                      <div class="idx_pros_desc flexrow">

                        <div style="color: #ffffff;  text-align: left;    line-height: 36px; padding: 10%;">
                          <p class="hangyeyingyong"><strong>{{ fuwulist[1]['title'] }}</strong></p>
                          <p class="buxianshi">{{ fuwulist[1]['description'] }}</p>
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>

      </div>
    </section>
    <!-- Employee Area End -->


    <!-- News Area Starts -->
    <section class="section-padding7 section">
      <div class="container">
        <div class="row donghuasun" style="animation-duration: 1s; animation-delay: 0.3s;">
          <div class="col-lg-12">
            <div class="section-top xinwen_biaoti" style="margin-bottom: 30px;">
              <h2 style="color: #44BCB9;font-weight: 500;font-size: 24px;">NEWS</h2>
              <p style="font-style: normal;font-size: 24px;">新闻资讯</p>
            </div>
          </div>
        </div>
        <div class="row donghuaLeft" style="animation-duration: 1s; animation-delay: 0.6s;">



          <div v-for="(item, index) in newslist" :key="index" class="col-lg-4 col-md-6" style="cursor: pointer; ">
            <a :href="'/blogDetails?id=' + item.id + '&cid=' + item.scode" target="_blank" style="color: black;">
              <div class="single-news mb-5 mb-lg-0 qudiaodibu">
                <div class="news-img news-img1" :style="'background-image: url(' + newurl + item.ico + '); left: 50%;'">
                </div>
                <div class="news-tag qudiaomarg" style="padding: 0px 20px;">
                  <ul class="my-4 qudiaomarg" style="font-size: 20px;">
                    <li>
                      <h5 style="font-size: 16px;"><i class="fa fa-calendar-o"></i>{{ truncateDate(item.date) }}</h5>
                    </li>
                    <li class="separator mx-2"><span></span></li>
                    <li>
                      <h5 style="font-size: 16px;">{{ item.sortname }}</h5>
                    </li>
                  </ul>
                </div>
                <div class="news-title" style="padding: 0px 20px;">
                  <h4 style="line-height: 28px;" class="bianhuaduoduan"><a href="#" class="xinwen">{{
                    truncatetitle(item.title) }}..</a>
                  </h4>
                  <p style="font-size: 16px;color: #666666;" class="buxianshi">{{ truncatecontent(item.description) }} ...
                  </p>
                  <p style="font-size: 16px;color: #666666;margin-top: 50px;" class="buxianshi">了解更多 >></p>
                </div>
              </div>
            </a>
          </div>



        </div>
        <div class="donghuaRight"
          style="width: 100%;height: 100px;text-align: center; line-height: 100px; animation-duration: 1s; animation-delay: 0.6s;">
          <a href="/blog?id=15" target="_blank">
            <div class="download-btn">
              查看全部新闻 +
            </div>
          </a>
        </div>
      </div>
    </section>
    <!-- News Area End -->

    <!-- 合作伙伴 starts -->

    <!-- <section class="section-padding8 section">


      <div class="container">
        <div class="donghuasun zuote_tx"
          style="width: 100%; padding-top: 2%; text-align: center;animation-duration: 1s; animation-delay: 0.3s;">
          <p style="    font-size: 24px; color: #44BCB9;">PARTNERS</p>
          <p style="font-size: 24px; color: #666666;">合作伙伴</p>
        </div>
        <div class="tablea slider">

          <div class="slider-container">
            <div class="slide">
              <div class="shojilaoxunhome" style="width: 79%;  height: 100%;">
                <div class="xintablea" v-for="(item, index) in huobanlist" :key="index">
                  <a :href="item.apilink" target="_blank"> <img :src="newurl + item['ico']" class="donghuasunfadeIn"
                      style="animation-duration: 1s; animation-delay: 0.6s;" /></a>
                </div>
              </div>
            </div>
            <div class="slide">
              <div class="shojilaoxunhome" style="width: 79%;  height: 100%;">
                <div class="xintablea" v-for="(item, index) in huobanlista" :key="index">
                  <a :href="item.apilink" target="_blank"> <img :src="newurl + item['ico']" class="donghuasunfadeIn"
                      style="animation-duration: 1s; animation-delay: 0.6s;" /></a>
                </div>
              </div>
            </div>
          </div>

     




        </div>
      </div>

    </section> -->

    <!-- 合作伙伴 end -->


    <!-- Footer Area Starts -->
    <section class="footer-area section-padding9 section">
      <div class="footer-widget">
        <div class="container">
          <div class="row">

            <div class="col-xl-5 offset-xl-1 col-lg-6">
              <div class="single-widget-home mb-5 mb-lg-0 donghuaLeft phone_weibu_kd"
                style="animation-duration: 0.5s; animation-delay: 0.3s;">
                <h3 class="mb-4 phone_weibu_zt1" style="font-weight: 500;font-size: 24px;">专业技术团队 提供全方位系统解决方案</h3>
                <p class="mb-4" style="color: #7a7a7a;line-height: 60px;">如有任何疑问 请随时与我们联系</p>
                <form>

                  <input type="messname" v-model="messname" placeholder="您的姓名" onfocus="this.placeholder = ''"
                    onblur="this.placeholder = '您的姓名'" required>
                  <input type="messtel" v-model="messtel" placeholder="您的电话" onfocus="this.placeholder = ''"
                    onblur="this.placeholder = '您的电话'" required>
                  <input type="messtitle" v-model="messtitle" placeholder="您的留言" onfocus="this.placeholder = ''"
                    onblur="this.placeholder = '您的留言'" required>
                  <button type="submit" class="template-btnb" @click="buttonmess"
                    style="background: rgb(0 100 207);">立即提交</button>
                </form>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="footer-copyright weibu_sun">
        <div class="container  weibu912" style="padding-top: 2%;">
          <div class="weibu_a donghuasun" style="animation-duration: 0.6s; animation-delay: 0.3s;">
            <img src="/static/assets/images/logob.png" />
            <div class="image-counter">
              <div class="image-containerc"></div>
              <div class="image-containera"></div>
              <div class="image-containerb"></div>
              <!-- <img src="/static/assets/images/weixin.png" style="width: 35px;height: 35px;">
					<img src="/static/assets/images/douyin.png" style="width: 35px;height: 35px;">
					<img src="/static/assets/images/weibo.png" style="width: 35px;height: 35px;"> -->
            </div>
          </div>
          <div class="weibu_b donghuasun" style="animation-duration: 0.6s; animation-delay: 0.4s;">
            <p style="font-size: 20px;">工业物联网整体解决方案服务商</p>
            <p style="font-size: 20px;">智能传感解决方案专家</p>
          </div>
          <div class="weibu_c donghuasun" style="animation-duration: 0.6s; animation-delay: 0.5s;">
            <p>{{ zhandianinfo.copyright }}</p>
            <p>总部公司 : {{ qiyeinfo.address }}</p>
            <p>服务热线 : {{ qiyeinfo.mobile }}</p>
            <p>主营产品 : {{ qiyeinfo.other }}</p>
            <p>{{ zhandianinfo.icp }} <i><img src="/static/assets/images/gongan.png"
                  style="width:16px; height:16px;margin-bottom: 5px;"></i></p>
          </div>
        </div>
      </div>
    </section>
    <!-- Footer Area End -->

  </div>
</template>

<script>

import axios from 'axios';

export default {
  data() {
    return {
      newurl: 'https://naduapi.jurenkeji.com.cn',
      aboutinfo: '',
      messtel: '',
      messname: '',
      messtitle: '',
      lanmulist: [],
      qiyeinfo: [],
      zhandianinfo: [],
      prbuclist: [
        {
          id: '',

        },
        {
          id: '',

        },
        {
          id: '',

        },
        {
          id: '',

        }
      ],
      huobanlist: [
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
      ],
      huobanlista: [
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
      ],
      newslist: [],
      fuwulist: [
        {
          ico: "/static/upload/image/20240806/1722927385513502.jpg",
          id: "108",
          title: "半导体（拿度）",
          description: "在半导体芯片制造工程中",
        },
        {
          pics: "/static/upload/image/20240806/1722927385513502.jpg",
          id: "108",
          title: "半导体（拿度）",
          description: "在半导体芯片制造工程中",
        },
        {
          pics: "/static/upload/image/20240806/1722927385513502.jpg",
          id: "108",
          title: "半导体（拿度）",
          description: "在半导体芯片制造工程中",
        },
        {
          ico: "/static/upload/image/20240806/1722927385513502.jpg",
          id: "108",
          title: "半导体（拿度）",
          description: "在半导体芯片制造工程中",
        },
        {
          pics: "/static/upload/image/20240806/1722927385513502.jpg",
          id: "108",
          title: "半导体（拿度）",
          description: "在半导体芯片制造工程中",
        }
      ],
      hangyelist: [
        {
          ico: "/static/upload/image/20240806/1722927385513502.jpg",
          id: "108",
          title: "半导体（拿度）",
          description: "在半导体芯片制造工程中",
        },
        {
          pics: "/static/upload/image/20240806/1722927385513502.jpg",
          id: "108",
          title: "半导体（拿度）",
          description: "在半导体芯片制造工程中",
        },
        {
          pics: "/static/upload/image/20240806/1722927385513502.jpg",
          id: "108",
          title: "半导体（拿度）",
          description: "在半导体芯片制造工程中",
        },
        {
          ico: "/static/upload/image/20240806/1722927385513502.jpg",
          id: "108",
          title: "半导体（拿度）",
          description: "在半导体芯片制造工程中",
        },
        {
          pics: "/static/upload/image/20240806/1722927385513502.jpg",
          id: "108",
          title: "半导体（拿度）",
          description: "在半导体芯片制造工程中",
        }
      ],
      fanganlist: [
        {
          pics: "/static/upload/image/20240806/1722923425968374.jpg",
          id: "104",
          title: "工程机械设备智能领域",
          description: "超声波传感器具有频率高、波长短、绕射现象小，特别是方向性好、能够成为射线而定向传播等特点。超声波对液体、固体的穿透本领很大，尤其是在阳光不透明的固体中。广泛应用于工业无损探伤、测厚、物位（液位）监测，机器人防撞，各种超声波接近开关，防盗报警，以及国防、医疗等相关领域。",
        },
        {
          pics: "/static/upload/image/20240806/1722923368670619.jpg",
          id: "103",
          title: "汽车设备智能制造领域",
          description: "磁致伸缩位移传感器具有高可靠性、高分辨率、非接触测量、耐油抗污等特殊优点，能在恶劣的工业环境下，对各种运动部件的位移（位置）、速度进行连续、精确、实时的检测，是实现精确操作和控制的重要元件，可大幅提高整个系统的精度和效率。",
        },
        {
          pics: "/static/upload/image/20240806/1722923303305293.jpg",
          id: "102",
          title: "芯片设备制造领域",
          description: "激光传感器的优点是能实现无接触远距离测量，速度快，精度高，量程大，抗光、电干扰能力强等。广泛应用于长度、距离、振动、速度、方位等物理量的测量，还可用于探伤和大气污染物的监测等。",
        }
      ],
      bannerlist: [
        {
          acode: "cn",
          create_time: "2024-06-18 17:23:41",
          create_user: "admin",
          gid: "1",
          id: "9",
          link: "",
          pic: "../../static/assets/images/bannerc.jpg",
          sorting: "255",
          subtitle: "A source of motivation to explore the unknown",
          title: "探索未知世界的源动力",
          update_time: " 2024-08-05 15:55:29",
          update_user: "admin"
        },
        {
          acode: "cn",
          create_time: "2024-08-05 15:56:06",
          create_user: "admin",
          gid: "1",
          id: "10",
          link: "",
          pic: "../../static/assets/images/bannerc.jpg",
          sorting: "255",
          subtitle: "A source of motivation to explore the unknown",
          title: "探索未知世界的源动力 测试1",
          update_time: " 2024-08-05 15:56:16",
          update_user: "admin"
        },
        {
          acode: "cn",
          create_time: "2024-08-05 15:56:29",
          create_user: "admin",
          gid: "1",
          id: "11",
          link: "",
          pic: "../../static/assets/images/bannerc.jpg",
          sorting: "255",
          subtitle: "A source of motivation to explore the unknown",
          title: "探索未知世界的源动力 测试2",
          update_time: "2024-08-05 15:56:29",
          update_user: "admin"
        },
        {
          acode: "cn",
          create_time: "2024-08-05 15:56:49",
          create_user: "admin",
          gid: "1",
          id: "12",
          link: "",
          pic: "../../static/assets/images/bannerc.jpg",
          sorting: "255",
          subtitle: "A source of motivation to explore the unknown",
          title: "探索未知世界的源动力 测试3",
          update_time: "2024-08-05 15:56:49",
          update_user: "admin"
        }
        // ,
        // {
        //   acode: "cn",
        //   create_time: "2024-08-05 15:57:06",
        //   create_user: "admin",
        //   gid: "1",
        //   id: "13",
        //   link: "",
        //   pic: "../../static/assets/images/bannerc.jpg",
        //   sorting: "255",
        //   subtitle: "A source of motivation to explore the unknown",
        //   title: "探索未知世界的源动力 测试4",
        //   update_time: " 2024-08-05 15:57:14",
        //   update_user: "admin"
        // },
        // {
        //   acode: "cn",
        //   create_time: "2024-08-05 15:57:58",
        //   create_user: "admin",
        //   gid: "1",
        //   id: "14",
        //   link: "",
        //   pic: "../../static/assets/images/bannerc.jpg",
        //   sorting: "255",
        //   subtitle: "A source of motivation to explore the unknown",
        //   title: "探索未知世界的源动力 测试5",
        //   update_time: "2024-08-05 15:57:58",
        //   update_user: "admin"
        // },
        // {
        //   acode: "cn",
        //   create_time: "2024-08-05 15:58:13",
        //   create_user: "admin",
        //   gid: "1",
        //   id: "15",
        //   link: "",
        //   pic: "../../static/assets/images/bannerc.jpg",
        //   sorting: "255",
        //   subtitle: "A source of motivation to explore the unknown",
        //   title: "探索未知世界的源动力 测试6",
        //   update_time: "2024-08-05 15:58:13",
        //   update_user: "admin"
        // },
        // {
        //   acode: "cn",
        //   create_time: "2024-08-05 15:58:40",
        //   create_user: "admin",
        //   gid: "1",
        //   id: "17",
        //   link: "",
        //   pic: "../../static/assets/images/bannerc.jpg",
        //   sorting: "255",
        //   subtitle: "A source of motivation to explore the unknown",
        //   title: "探索未知世界的源动力 测试7",
        //   update_time: "2024-08-05 15:58:40",
        //   update_user: "admin"
        // },
        // {
        //   acode: "cn",
        //   create_time: "2024-08-05 15:58:55",
        //   create_user: "admin",
        //   gid: "1",
        //   id: "18",
        //   link: "",
        //   pic: "../../static/assets/images/bannerc.jpg",
        //   sorting: "255",
        //   subtitle: "A source of motivation to explore the unknown",
        //   title: "探索未知世界的源动力 测试8",
        //   update_time: "2024-08-05 15:58:55",
        //   update_user: "admin"
        // },

      ]
    }
  },
  mounted() {
    // 在组件挂载完成后立即请求接口
    //banner图接口
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/slide/gid/1/num/4', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.bannerlist = response.data.data;
      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });
    //产品中心



    



    // 等待10秒后执行输出
    // setTimeout(() => {


    //产品列表list
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/7/num/4/order/sorting', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.prbuclist = response.data.data;
      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });
    ////产品首页分类分类信息
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/nav/scode/7', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        console.log(response.data.data);
        this.lanmulist = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });
     
    // }, 3000); // 10000 毫秒即 10 秒



    

    // 等待10秒后执行输出
    setTimeout(() => {


      
    //解决方案
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/13/num/3/order/sorting', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.fanganlist = response.data.data;
      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });
    //公司简介
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/content/236', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.aboutinfo = response.data.data;
      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });
      
    }, 6000); // 10000 毫秒即 10 秒

    // 等待10秒后执行输出
    setTimeout(() => {

      
      //行业应用
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/26/num/4/order/sorting', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.hangyelist = response.data.data;
      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });
      
    }, 7000); // 10000 毫秒即 10 秒

    







          // 等待10秒后执行输出
    setTimeout(() => {
            //技术服务
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/50/num/5/order/sorting', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.fuwulist = response.data.data;
      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });

      
          //合作伙伴1
          // axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/17/num/20/order/sorting', {
          //   appid: 'jurenkeji2024',
          //   timestamp: '1722845854',
          //   signature: '0eb76b812e96966c380b90c6e7416a26'
          // })
          //   .then(response => {
          //     this.huobanlist = response.data.data;
          //   })
          //   .catch(error => {
          //     console.error('当前网络环境异常!', error);
          //   });

          //合作伙伴2
          // axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/17/num/20/page/2/order/sorting', {
          //   appid: 'jurenkeji2024',
          //   timestamp: '1722845854',
          //   signature: '0eb76b812e96966c380b90c6e7416a26'
          // })
          //   .then(response => {
          //     this.huobanlista = response.data.data;
          //   })
          //   .catch(error => {
          //     console.error('当前网络环境异常!', error);
          //   });
    }, 8000); // 10000 毫秒即 10 秒




    
          // 等待10秒后执行输出
          setTimeout(() => {

              
            //新闻中心
            axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/14/num/4/order/sorting', {
              appid: 'jurenkeji2024',
              timestamp: '1722845854',
              signature: '0eb76b812e96966c380b90c6e7416a26'
            })
              .then(response => {
                // console.log(response.data.data);
                this.newslist = response.data.data;
              })
              .catch(error => {
                console.error('当前网络环境异常!', error);
              });

            }, 10000); // 10000 毫秒即 10 秒



     // 等待10秒后执行输出
     setTimeout(() => {


    //公司信息
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/company', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.qiyeinfo = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });
    //站点信息
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/site', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.zhandianinfo = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });


      
    }, 6500); // 10000 毫秒即 10 秒


  },


  created() {
    // this.fetchbanner()
  },
  methods: {
    // 截取日期字符串至指定长度
    truncateDate(dateStr, length = 10) {
      return dateStr.substring(0, length);
    },
    // 截取新闻内容字符串至指定长度
    truncatetitle(dateStr, length = 10) {
      return dateStr.substring(0, length);
    },
    // 截取新闻标题字符串至指定长度
    truncatecontent(dateStr, length = 80) {
      return dateStr.substring(0, length);
    },
    // 截取产品中心产品标题指定长度
    truncatechanpin(dateStr, length = 8) {
          return dateStr.substring(0, length);
    },

    //提交留言
    buttonmess() {
      // Message.success(`输入的内容是: ${this.messtitle}`);
      if (this.messname != '' && this.messtel != '' && this.messtitle) {
        // console.log('可以继续进行');
        // console.log('输入的内容是:', this.messname);
        // console.log('输入的内容是:', this.messtel);
        // console.log('输入的内容是:', this.messtitle);
        axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/addmsg', {
          name: this.messname,
          tel: this.messtel,
          content: this.messtitle,
          appid: 'jurenkeji2024',
          timestamp: '1722845854',
          signature: '0eb76b812e96966c380b90c6e7416a26'
        })
          .then(response => {
            // console.log(response.data.data);
            // that.bannerlist = response.data.data;
            alert('留言提交成功!');
            this.messname = '';
            this.messtel = '';
            this.messtitle = '';
          })
          .catch(error => {
            console.error('当前网络环境异常!', error);
          });

      } else {
        alert('内容不能为空');
        return;
        // console.log('不能为空');
      }

    }
    // async fetchbanner(){
    // 	var that = this

    // 	axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/slide/gid/1/num/10', {
    // 	      appid: 'jurenkeji2024',
    // 	      timestamp: '1722845854',
    // 	      signature: '0eb76b812e96966c380b90c6e7416a26'
    // 		})
    // 		.then(response => {
    // 			// console.log(response.data.data);
    // 			that.bannerlist = response.data.data;
    // 		})
    // 		.catch(error => {
    // 			console.error('当前网络环境异常!', error);
    // 		});

    // }
  }
}



</script>
<style>
#section2 {
  background-color: #8FB98B !important;
  /* 页面1的背景颜色 */
}

.slider {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.slider-container {
  display: grid;
  grid-template-columns: repeat(3, 100vw);
  width: 300vw;
  transition: transform 0.5s ease-in-out;
}

.slide {
  width: 100vw;
  height: 100vh;
  /* 根据需要设置高度 */
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
}
</style>




// WEBPACK FOOTER //
// Home.vue?215df636